import * as React from 'react';
import Button from '@telia-front/button';
import PropsChecker from '@telia-front/props-checker';
const Readmore = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Readmore", defaultValueName: "defaultIsHidden", valueName: "isHidden", onChangeNames: "onToggle" },
        React.createElement(ReadmoreInner, Object.assign({}, props))));
};
export default Readmore;
export class ReadmoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonClick = (event) => {
            event.preventDefault();
            if (typeof this.props.isHidden === 'undefined') {
                this.setState(prevState => ({
                    isHidden: !prevState.isHidden,
                }));
            }
            if (this.props.onToggle) {
                this.props.onToggle(!this.isHidden);
            }
        };
        this.state = {
            isHidden: typeof props.defaultIsHidden !== 'undefined' ? props.defaultIsHidden : true,
        };
    }
    get isHidden() {
        return this.props.onToggle && typeof this.props.isHidden !== 'undefined' ? this.props.isHidden : this.state.isHidden;
    }
    getText() {
        if (this.isHidden) {
            return this.props.text.substring(0, this.props.charsToShow) + '... ';
        }
        else {
            return this.props.text + ' ';
        }
    }
    getButton() {
        const text = !this.isHidden && this.props.lessText ? this.props.lessText : this.props.moreText;
        if (this.isHidden || (!this.isHidden && this.props.lessText)) {
            return React.createElement(Button, { text: text, link: true, onClick: this.onButtonClick, type: this.props.type });
        }
        return null;
    }
    BEM() {
        const classArray = ['readmore'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            this.getText(),
            this.getButton()));
    }
}
ReadmoreInner.defaultProps = {
    charsToShow: 100,
};
